module.exports = __webpack_public_path__ + "static/angus-burger-f9bc2dbd512d827f1f7f6162702a5219.jpg";